import { AppButton, ConfirmDialog, Tooltip } from '@clickguard/design-system'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAccountStore, useAssetStore, useUiStore, useUserStore } from 'store'
import { useShallow } from 'zustand/react/shallow'

const RemoveWebsiteSection = () => {
	const {
		asset,
		demoMode,
		setAsset,
		setDemoMode,
		accountsWithAssets,
		removeAsset
	} = useAssetStore(
		useShallow((state) => ({
			asset: state.asset,
			demoMode: state.demoMode,
			setAsset: state.setAsset,
			setDemoMode: state.setDemoMode,
			accountsWithAssets: state.accountsWithAssets,
			removeAsset: state.deleteAsset
		}))
	)

	const { account, userAccess } = useAccountStore(
		useShallow((state) => ({
			account: state.account,
			userAccess: state.userAccess
		}))
	)
	const { user } = useUserStore(useShallow((state) => ({ user: state.user })))
	const isLoading = useUiStore((s) => s.isLoading)
	const navigate = useNavigate()
	const [confirmOpen, setConfirmOpen] = useState(false)

	const deleteAsset = async () => {
		try {
			await removeAsset(account?.id, asset?.id)
			const filterAccount = accountsWithAssets
				.find((accountWithAss) => accountWithAss.id === account.id)
				.assets.filter((a) => a.id !== asset.id)
			let assetId = 'website-demo'
			if (filterAccount.length > 0) {
				const asset = filterAccount[0]
				setAsset(asset)
				assetId = asset.id
			} else {
				setAsset(null)
				setDemoMode(true)
			}
			navigate(`/workspace/${account.id}/asset/${assetId}`)
		} catch (e) {
			//
		}
	}

	const disabledReason = demoMode
		? 'This action is disabled when demo data is displayed'
		: userAccess(user?.id) === 'READ'
		? 'Analysts don’t have permission for this action'
		: undefined

	const deleteButton = (
		<AppButton
			variant="destructive"
			size="md"
			label="Delete"
			disabled={demoMode || userAccess(user?.id) === 'READ'}
			onClick={() => setConfirmOpen(true)}
		/>
	)

	return (
		<div className="mt-4 flex flex-col gap-4 rounded-xl border border-t-traffic bg-white p-4 shadow-[0px_4px_8px_0px_rgba(16,24,40,0.03),0px_1px_2px_0px_rgba(16,24,40,0.02)]">
			<p className="text-[18px] leading-6 font-medium text-t-base-blue">
				Danger Zone
			</p>
			<div className="flex items-center justify-between gap-6">
				<p className="text-[16px] leading-[22px] font-medium text-t-danger">
					Remove website and all of its data
				</p>
				{disabledReason ? (
					<Tooltip content={disabledReason}>{deleteButton}</Tooltip>
				) : (
					deleteButton
				)}
			</div>
			<ConfirmDialog
				open={confirmOpen}
				onClose={() => setConfirmOpen(false)}
				onConfirm={deleteAsset}
				tone="danger"
				title="Remove website"
				description="The website and its data will be permanently removed."
				confirmLabel="Delete"
				loading={isLoading('ASSET_DELETE_SITE')}
			/>
		</div>
	)
}

export default RemoveWebsiteSection
